import React, { useEffect } from 'react';
import { Container, Typography, Paper, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Strona sukcesu uwierzytelniania
 */
const AuthSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    // 1) Pobierz token i redirect z URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const redirectTo = urlParams.get('redirect') || '/';

    if (token) {
      // 2) Zaloguj w aplikacji web
      login(token);

      // 3) Spróbuj otworzyć aplikację mobilną (zamyka SFSafariViewController na iOS) – tylko gdy brak redirect (standardowy flow)
      if (!redirectTo || redirectTo === '/') {
        const deepLinkUrl = `unitresco://auth/success?token=${encodeURIComponent(token)}`;
        try {
          setTimeout(() => { window.location.href = deepLinkUrl; }, 50);
        } catch {}
      }

      // 4) Usuń token z paska adresu
      try {
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      } catch {}

      // 5) Przekieruj po 2s – na redirect (np. /cad) lub na stronę główną
      const redirectTimer = setTimeout(() => { navigate(redirectTo); }, 2000);
      return () => clearTimeout(redirectTimer);
    }

    // Brak tokenu – wróć do logowania
    navigate('/login');
  }, [login, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
          <Box sx={{ mb: 3 }}>
            <CircularProgress size={60} thickness={4} />
          </Box>
          
          <Typography variant="h5" component="h1" gutterBottom>
            Logowanie zakończone sukcesem!
          </Typography>
          
          <Typography variant="body1" color="text.secondary">
            Trwa przekierowywanie do aplikacji...
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthSuccessPage;
